import axios from "axios";

export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("grc_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export function formatApiError(err) {
  const d = err?.response?.data?.detail;
  if (d == null) return err?.message || "Something went wrong";
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((e) => {
    const field = Array.isArray(e?.loc) ? e.loc.slice(-1)[0] : "";
    return field ? `${field}: ${e?.msg || ""}` : e?.msg || JSON.stringify(e);
  }).join(" · ");
  if (d?.msg) return d.msg;
  return String(d);
}
